import { Box, Card, Typography, Tooltip, IconButton, Skeleton } from '@material-ui/core';
import { Icon } from '@iconify/react';
import roundHelp from '@iconify/icons-ic/round-help';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

export function DevicesStatsCard() {
  const { online, total, isLoading } = useSelector((state: RootState) => state.devices);

  const calculateOffline = () => {
    if (total === undefined || online === undefined || isNaN(total) || isNaN(online)) return 0;
    const result = total - (total * online) / 100;
    return isNaN(result) ? 0 : Math.round(result);
  };

  const calculateOnline = () => {
    if (total === undefined || online === undefined || isNaN(total) || isNaN(online)) return 0;
    const result = (total * online) / 100;
    return isNaN(result) ? 0 : Math.round(result);
  };

  return (
    <>
      <Card sx={{ display: 'flex', alignItems: 'center', p: 3 }}>
        <Box display="flex" justifyContent="space-between" flexDirection="column" sx={{ flexGrow: 1, minHeight: 150 }}>
          <Box display="flex" flexDirection="column">
            <Box
              sx={{ height: 10, mt: 1, mb: 1 }}
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h6">Online</Typography>
              <Tooltip title="Dispositivos atualmente online" placement="right" arrow>
                <IconButton sx={{ color: '#919EAB' }}>
                  <Icon style={{ margin: 2 }} icon={roundHelp} width="20" height="20" />
                </IconButton>
              </Tooltip>
            </Box>
            <Typography color="primary" component="span" variant="h1" sx={{ mt: 1, mb: 1 }}>
              {isLoading ? (
                <Skeleton sx={{ mt: 2, mb: 1 }} animation="wave" variant="rectangular" width={100} height={30} />
              ) : (
                Math.round(calculateOnline())
              )}
            </Typography>
          </Box>
        </Box>
      </Card>
      <Card sx={{ display: 'flex', alignItems: 'center', p: 3, mt: 2 }}>
        <Box display="flex" justifyContent="space-between" flexDirection="column" sx={{ flexGrow: 1, minHeight: 150 }}>
          <Box display="flex" flexDirection="column">
            <Box
              sx={{ height: 10, mt: 1, mb: 1 }}
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h6">Offline</Typography>
              <Tooltip title="Dispositivos atualmente offline" placement="right" arrow>
                <IconButton sx={{ color: '#919EAB' }}>
                  <Icon style={{ margin: 2 }} icon={roundHelp} width="20" height="20" />
                </IconButton>
              </Tooltip>
            </Box>
            <Typography color="error" component="span" variant="h1" sx={{ mt: 1, mb: 1 }}>
              {isLoading ? (
                <Skeleton sx={{ mt: 2, mb: 1 }} animation="wave" variant="rectangular" width={100} height={30} />
              ) : (
                Math.round(calculateOffline())
              )}
            </Typography>
          </Box>
        </Box>
      </Card>
    </>
  );
}
